module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/full-print/5-1fb2953a698d361d586d53ba96f29379.jpg";